import { onBeforeUpdate as _onBeforeUpdate2 } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate } from "gyron";
import { h as _h } from "gyron";
import { createBrowserRouter, Route, Router, Routes } from '@gyron/router';
import { createSSRContext, FC } from 'gyron';
import { MdxHelper } from './components/helper';
import { MdxContainer } from './components/mdx';
import { Mismatch } from './components/mismatch';
import { Skeleton } from './components/skeleton';
import { Layout } from './layout';
import { CORE_INDEX, CoreDocs, CORE_ROUTE_MENUS, Docs, Home, ROUTE_MENUS, Editor, BlogDocs, BLOG_ROUTE_MENUS, ROUTE_MENUS_EN, CORE_ROUTE_MENUS_EN, BLOG_ROUTE_MENUS_EN } from './pages';
import { storeState } from './store';
import { Lang } from './components/translate';
import { $t, TranslateProvider } from './langs';
import { CORE_INDEX_EN } from './pages/core';
const base = process.env.PUBLISH_BASE;
const Content = FC(({
  menu,
  parentPath,
  lang
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props = props;
    menu = _props.menu;
    parentPath = _props.parentPath;
    lang = _props.lang;
  })
  return ({
    menu,
    parentPath,
    lang
  }) => _h(TranslateProvider, {
    "lang": lang
  }, _h(MdxContainer, {
    "lang": lang,
    "menu": menu,
    "parentPath": parentPath
  }, _h(menu.component, {
    "fallback": _h(Skeleton, {
      "length": 3
    }, []),
    "components": MdxHelper
  }, [])));
});
export const ExposeRoutes = FC(() => {
  return () => _h(Routes, {}, [_h(Route, {
    "path": Lang.EN
  }, [_h(Route, {
    "path": "",
    "strict": true,
    "meta": {
      title: $t('StringLiteral_54_25_54_29', Lang.EN)
    },
    "element": _h(TranslateProvider, {
      "lang": Lang.EN
    }, _h(Home, {}, []))
  }, []), _h(Route, {
    "path": "docs",
    "element": _h(Docs, {
      "lang": Lang.EN
    }, [])
  }, ROUTE_MENUS_EN.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "en-US/docs",
      "lang": Lang.EN
    }, [])
  }, []))), _h(Route, {
    "path": "core",
    "element": _h(CoreDocs, {
      "lang": Lang.EN
    }, [])
  }, [_h(Route, {
    "index": true,
    "meta": CORE_INDEX_EN.meta,
    "element": _h(Content, {
      "menu": CORE_INDEX_EN,
      "parentPath": "en-US/core",
      "lang": Lang.EN
    }, [])
  }, []), CORE_ROUTE_MENUS_EN.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "en-US/core",
      "lang": Lang.EN
    }, [])
  }, []))]), _h(Route, {
    "path": "blog",
    "element": _h(BlogDocs, {
      "lang": Lang.EN
    }, [])
  }, BLOG_ROUTE_MENUS_EN.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "en-US/blog",
      "lang": Lang.EN
    }, [])
  }, []))), _h(Route, {
    "path": "explorer",
    "meta": {
      title: $t('StringLiteral_103_25_103_44', Lang.EN)
    },
    "element": _h(TranslateProvider, {
      "lang": Lang.EN
    }, _h(Editor, {}, []))
  }, []), _h(Route, {
    "path": "*",
    "meta": {
      title: $t('StringLiteral_158_23_158_34', Lang.EN)
    },
    "element": _h(Mismatch, {}, [])
  }, [])]), _h(Route, {
    "path": "",
    "strict": true,
    "meta": {
      title: $t('StringLiteral_110_23_110_27', Lang.ZH)
    },
    "element": _h(TranslateProvider, {
      "lang": Lang.ZH
    }, _h(Home, {}, []))
  }, []), _h(Route, {
    "path": "docs",
    "element": _h(Docs, {
      "lang": Lang.ZH
    }, [])
  }, ROUTE_MENUS.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "docs",
      "lang": Lang.ZH
    }, [])
  }, []))), _h(Route, {
    "path": "core",
    "element": _h(CoreDocs, {
      "lang": Lang.ZH
    }, [])
  }, [_h(Route, {
    "index": true,
    "meta": CORE_INDEX.meta,
    "element": _h(Content, {
      "menu": CORE_INDEX,
      "parentPath": "core",
      "lang": Lang.ZH
    }, [])
  }, []), CORE_ROUTE_MENUS.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "core",
      "lang": Lang.ZH
    }, [])
  }, []))]), _h(Route, {
    "path": "blog",
    "element": _h(BlogDocs, {
      "lang": Lang.ZH
    }, [])
  }, BLOG_ROUTE_MENUS.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "blog",
      "lang": Lang.ZH
    }, [])
  }, []))), _h(Route, {
    "path": "explorer",
    "meta": {
      title: $t('StringLiteral_153_23_153_42', Lang.ZH)
    },
    "element": _h(Editor, {}, [])
  }, []), _h(Route, {
    "path": "*",
    "meta": {
      title: $t('StringLiteral_158_23_158_34', Lang.ZH)
    },
    "element": _h(Mismatch, {}, [])
  }, [])]);
});
export const App = FC(({
  isSSR,
  lang = Lang.ZH
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props2 = props;
    isSSR = _props2.isSSR;
    var _props2$lang = _props2.lang;
    lang = _props2$lang === void 0 ? Lang.ZH : _props2$lang;
  })
  return ({
    isSSR,
    lang = Lang.ZH
  }) => _h(Layout, {
    "lang": lang
  }, _h(ExposeRoutes, {}, []));
});
export const app = (lang = Lang.ZH) => {
  const router = createBrowserRouter({
    base: base || '/',
    beforeEach: (from, to, next) => {
      next();
    },
    afterEach: (from, to) => {
      if (to.meta) {
        const title = `Gyron.js | ${to.meta.title}`;
        document.title = title;
        const og = document.querySelector('meta[property="og:title"]');
        if (og) {
          og.content = title;
        }
      }
      if (from.path !== to.path) {
        for (const k in storeState.guidance) {
          Reflect.deleteProperty(storeState.guidance, k);
        }
      }
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  });
  return createSSRContext({
    message: {}
  }).render(_h(Router, {
    "router": router
  }, _h(App, {
    "lang": lang
  }, [])), '#app');
};